/**
 * 라우터 path name
 * [!] '메뉴'에서 사용하는 값을 변경할 경우 TSYS350 테이블의 PATH_NAME 컬럼값도 함께 변경해야함 (*)
 */
export default {
  PolicyConsent: 'policyConsent', // 약관동의(앱최초)
  PolicyConsentService: 'policyConsentService', // 약관동의(앱최초)
  PolicyConsentPrivacy: 'policyConsentPrivacy', // 약관동의(앱최초)
  Login: 'login', // 로그인

  Main: 'main', // 메인
  MemberSearch: 'memberSearch', // 직원검색
  Calendar: 'calendar', // 일정
  AllMenu: 'allMenu', // (전체)메뉴

  WorkTimeSta: 'workTimeSta', // 근무현황 *
  OrgGntWorkSta: 'orgGntWorkSta', // 부서원근태현황 *
  WorkOverTimeSta: 'workOverTimeSta', // 연장근무보상시간 *
  AnnualHolidaySta: 'annualHolidaySta', // 연차휴가현황 *
  MaternityHolidaySta: 'maternityHolidaySta', // 배우자출산휴가현황 *
  AnnualPlan: 'annualPlan', // 연차휴가계획목록 *
  AnnualPlanWrite: 'annualPlanWrite', // 연차휴가계획작성 *
  SelectPayGubun: 'selectPayGubun', // 급여구분선택 *
  CertiSta: 'certiSta', // 제증명현황 *

  ApprDoc: 'apprDoc', // 결재할문서 *
  MyBox: 'myBox', // 내문서함 *
  ReferBox: 'referBox', // 참조함 *
  WorkLog: 'workLog', // 업무일지 *

  ApplicationMenu: 'applicationMenu', // 신청서메뉴
  CancelMenu: 'cancelMenu', // 취소신청서메뉴
  GntTypeMenu: 'gntTypeMenu', // 근태명 선택메뉴
  GntGubunMenu: 'gntGubunMenu', // 근태종류 선택메뉴
  CertiTypeMenu: 'certiTypeMenu', // 제증명서종류 선택메뉴
  Application: 'application', // 신청서 *
  StartDate: 'startDate', // 시작일선택
  EndDate: 'endDate', // 종료일선택
  SelectTime: 'selectTime', // 시간선택
  ApprovalLine: 'approvalLine', // 결재라인
  ExtraOptions: 'extraOptions', // 추가옵션
  ApplicationConfirm: 'applicationConfirm', // 신청서완료뷰
  ConfirmOtWorkTime: 'confirmOtWorkTime', // 연장근무신청시간확인
  SelectAlterDate: 'selectAlterDate', // 대체휴가설정
  SelectSchedule: 'selectSchedule', // 근무스케줄선택
  SelectCertiOptions: 'selectCertiOptions', // 제증명서 신청옵션
  BizTripTypeMenu: 'bizTripTypeMenu', // 출장신청구분메뉴
  SelectBizTripJoiner: 'selectBizTripJoiner', // 출장동행자 선택

  NewMember: 'newMember', // 신규입사자 *
  Board: 'board', // 게시판(공지사항) *

  SettingMenu: 'settingMenu', // 설정메뉴
  PasswordChange: 'passwordChange', // 비밀번호변경(설정내부)
  ServicePolicy: 'servicePolicy', // 서비스이용약관(설정내부)
  PrivacyPolicy: 'privacyPolicy', // 개인정보처리방침(설정내부)

  Error: 'error', // 에러화면
  Alert: 'alert', // 알림?
};
